'use client'

import {
  DONATION_PATH_ROOT,
  LND_PATH_ROOT,
  LND_PATH_SEGMENT,
} from '@/utils/donationPaths'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

/**
 * Hook to redirect popup windows to the appropriate confirmation page.
 * Handles cases where external providers land directly on success pages.
 */
export function usePopupConfirmRedirect() {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const hasRedirectedRef = useRef(false)

  useEffect(() => {
    if (typeof window === 'undefined' || hasRedirectedRef.current) return

    const isPopup = window.opener && !window.opener.closed
    if (!isPopup) return

    hasRedirectedRef.current = true

    const currentParams = new URLSearchParams(searchParams.toString())
    currentParams.set('from_legacy', 'true')

    const baseConfirmPath = pathname.includes(`/${LND_PATH_SEGMENT}/`)
      ? `${LND_PATH_ROOT}/confirm`
      : `${DONATION_PATH_ROOT}/confirm`
    const confirmUrl = `${baseConfirmPath}?${currentParams.toString()}`

    console.log('[PopupRedirect] Redirecting popup to:', confirmUrl)
    window.location.replace(confirmUrl)
  }, [searchParams, pathname])

  return typeof window !== 'undefined' && window.opener && !window.opener.closed
}

export default usePopupConfirmRedirect
